// src/components/ProcessingResults/StatusBar.jsx
import React from 'react';
import { Card } from 'react-bootstrap';
import { calculateMeanColor, calculateMedianPerChannel,
        calculateTrueMedianColor, calculateStdDev } from '../../utils/ColorUtils';

const StatusBar = ({ activeStage, info, selectedCells, gridStructure, colors, colorMode }) => {
  const getSelectionStats = () => {

    if (selectedCells.length === 0) return null;

    if (selectedCells.length === 1) {

      let selectedRect = null;
      let selectedColor = null;
      for (const row of gridStructure){

        let stopFlag = false;
        for (const cell of row) {
            if (cell.id === selectedCells[0]) {
                selectedRect = cell;
                try {
                    selectedColor = colors[cell.row][cell.col];
                } catch (error) {
                    selectedRect = null;
                    stopFlag = true;
                    break;
                }

                stopFlag = true;
                break;
            }
        }
        if (stopFlag) break;
      }
      if (selectedColor) {
        return `Selected: Cell (${selectedColor.row}, ${selectedColor.col}) -
        Confidence: ${(selectedColor.confidence * 100).toFixed(1)}% -
        Color: (R:${selectedColor.r}, G:${selectedColor.g}, B:${selectedColor.b})`;
      }
      else return null;
    } else {
      let selectedRects = [];
      let selectedColors = [];
      let confidences = [];
      let [rCodes, gCodes, bCodes] = [[], [], []];
      for (const row of gridStructure){
        let stopFlag = false;
        for (const cell of row) {
            if (selectedCells.includes(cell.id)) {
                try {
                    const color = colors[cell.row][cell.col];
                    rCodes.push(color.r);
                    gCodes.push(color.g);
                    bCodes.push(color.b);
                } catch (error) {
                    stopFlag = true;
                    break;
                }
            }
        }
        if (stopFlag) break;
      }

      if (rCodes.length > 0) {
        if (colorMode === 'mean') {
            const [rMean, gMean, bMean] = calculateMeanColor({rCodes, gCodes, bCodes});
            const rStd = calculateStdDev({array: rCodes, mean: rMean});
            const gStd = calculateStdDev({array: gCodes, mean: gMean});
            const bStd = calculateStdDev({array: bCodes, mean: bMean});
            return `Selected ${rCodes.length} cells -
                    Mean color: (R:${rMean}, G:${gMean}, B:${bMean}) -
                    Std: (R:${rStd.toFixed(2)}, G:${gStd.toFixed(2)}, B:${bStd.toFixed(2)})`;
        } else if (colorMode === 'median') {
            const [rMedian, gMedian, bMedian] = calculateMedianPerChannel({rCodes, gCodes, bCodes});
            return `Selected ${rCodes.length} cells -
                    Median color: (R:${rMedian}, G:${gMedian}, B:${bMedian})`;
        } else if (colorMode === 'trueMedian') {
            const [rMedian, gMedian, bMedian] = calculateTrueMedianColor({rCodes, gCodes, bCodes});
            return `Selected ${rCodes.length} cells -
                    Median color: (R:${rMedian}, G:${gMedian}, B:${bMedian})`;
        } else {
            return `Selected ${rCodes.length} cells - Wrong reduce type provided`;
        }
      }
    }
  };

  const selectionStats = getSelectionStats();

  return (
    <Card className="mt-3">
      <Card.Body className="py-2">
        <div className="d-flex justify-content-between align-items-center">
          <span className="text-muted">{info || 'Ready'}</span>
          {selectionStats && <span className="text-primary">{selectionStats}</span>}
        </div>
      </Card.Body>
    </Card>
  );
};

export default StatusBar;